<fullscreen-page>
  <navigation-column>
    <div class="p-2 h-100 d-flex flex-column">
      <div class="dx-field" style="margin: 0 0 5px;">
        <div class="dx-field-label">{{'System' | translate }}</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="classificationSystems"
                         [(value)]="selectedClassificationSystem"
                         [displayExpr]="getClassificationSystemDisplayText"
                         [disabled]="loadingClassificationClasses">
            <dxo-drop-down-options [width]="400"></dxo-drop-down-options>
          </dx-select-box>
        </div>
        <dx-button stylingMode="text" hint="{{ 'Klassifizierungs-System erstellen' | translate }}" type="default"
                   icon="plus" (onClick)="showCreateClassificationSystemPopup()"/>
        <dx-button stylingMode="text" hint="{{ 'Klassifizierungs-System duplizieren' | translate }}" type="default"
                   icon="copy" (onClick)="showDuplicateClassificationSystemPopup()"/>
        <dx-button stylingMode="text" hint="{{ 'Katalog mit System-Struktur erstellen' | translate }}" type="default"
                   icon="export" (onClick)="createCatalogWithClassification()"/>
        <dx-button *ngIf="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                   stylingMode="text" hint="{{ 'Klassifizierungs-System bearbeiten' | translate }}" type="default"
                   icon="edit" (onClick)="showEditClassificationSystem()"/>
        <dx-button *ngIf="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                   stylingMode="text" hint="{{ 'Klassifizierungs-System löschen' | translate }}" type="default"
                   icon="trash" (onClick)="deleteClassificationSystem()"/>
      </div>
      <classificationTree class="overflow-hidden"
                          [(selectedClassificationSystem)]="selectedClassificationSystem"
                          [(loadingClassificationClasses)]="loadingClassificationClasses"
                          [(classificationClasses)]="classificationClasses"
                          (selectedClassificationClassChanged)="fillFeaturesInClassificationClass($event)"/>
    </div>
  </navigation-column>
  <content-column helpSwitch="true" look="light">  
    <div slot="content" class="p-2 flex-fill overflow-hidden">
      <classificationGroup [(selectedClassificationClass)]="selectedClassificationClass"
                           [(selectedClassificationSystem)]="selectedClassificationSystem"
                           [(classificationClasses)]="classificationClasses"/>
    </div>
  </content-column>
</fullscreen-page>

<dx-popup [width]="500"
          [height]="300"
          [showTitle]="true"
          title="{{ 'Klassifizierungs-System erstellen' | translate }}"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          contentTemplate="popupContent"
          [(visible)]="createClassificationSystemPopupVisible">
  <dxi-toolbar-item widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    [options]="{ text: 'Erstellen' | translate, onClick: createClassificationSystem }">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'popupContent'">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="newClassificationSystem.name" [showClearButton]="true"></dx-text-box>
      </div>
    </div>
    <div *ngIf="loginService.isAdmin" class="dx-field">
      <div class="dx-field-label">{{ 'Global' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="newClassificationSystem.isGlobal"></dx-switch>
      </div>
    </div>
  </div>
</dx-popup>
